// extracted by mini-css-extract-plugin
module.exports = {"dialog_wrapper":"modal_dialog_wrapper__DzvgU","title_wrapper":"modal_title_wrapper__1u2b9","border_bottom":"modal_border_bottom__VAIRg","address":"modal_address__LiI7h"};